import { ApiResponse } from '@core/interface/api-response.interface';
import { Observable } from 'rxjs';
import { ExportListResponse } from '@core/interface/export-list.interface';
import { ExportPurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/export-purchase-dispute.request.dto';
import { Injectable } from '@angular/core';
import { PurchaseDisputeService } from '@core/services/entities/purchase-dispute.service';
import { AssignPurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/assign-purchase-dispute.request.dto';
import { CreatePurchaseDisputeMessageRequestDto } from '@domain/purchase-dispute/dtos/create-purchase-dispute-message.request.dto';
import { ListPurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/list-purchase-dispute.request.dto';
import { SummaryPurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/summary-purchase-dispute.request.dto';
import { UpdatePriorityPurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/update-priority-purchase-dispute.request.dto';
import { UpdateStatePurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/update-state-purchase-dispute.request.dto';
import { PurchaseDisputeRepository } from './purchase-dispute.repository';

@Injectable({ providedIn: 'root' })
export class PurchaseDisputeRepositoryService implements PurchaseDisputeRepository {
  constructor(private service: PurchaseDisputeService) {}

  list(request: ListPurchaseDisputeRequestDto) {
    return this.service.list(request);
  }

  show(refId: string) {
    return this.service.show(refId);
  }

  summary(request: SummaryPurchaseDisputeRequestDto) {
    return this.service.summary(request);
  }

  updateState(request: UpdateStatePurchaseDisputeRequestDto) {
    return this.service.updateState(request);
  }

  updatePriority(request: UpdatePriorityPurchaseDisputeRequestDto) {
    return this.service.updatePriority(request);
  }

  assign(request: AssignPurchaseDisputeRequestDto) {
    return this.service.assign(request);
  }

  createMessage(request: CreatePurchaseDisputeMessageRequestDto) {
    return this.service.createMessage(request);
  }

  export(
    request: ExportPurchaseDisputeRequestDto,
  ): Observable<ApiResponse<ExportListResponse>> {
    return this.service.export(request);
  }
}
